import {createUseStyles} from 'react-jss';
import {Theme} from './themes/default';
import bgImgDark from '../assets/images/bg1.png';
import bgImgLight from '../assets/images/bg2.png';
import bgWoodLight from "../assets/images/patternLemn.jpg";
import patternAlb from "../assets/images/patternAlb.jpg";

const useOurBeersStyles = createUseStyles((theme: Theme) => {
    return {
        section: {
            padding: theme.spacing(10),
            position: "relative",
            [theme.breakpoints.down("sm")]: {
                padding: theme.spacing(5),
            }
        },
        bgImgLight: {
            backgroundImage: `url(${bgImgLight})`
        },
        bgImgDark: {
            backgroundImage: `url(${bgImgDark})`
        },
        sectionTitle: {
            fontFamily: theme.fonts.poplar,
            fontSize: 'max(5vw,5vh)',
            color: theme.palette.primary.main,
            lineHeight: 1,
            marginBottom: theme.spacing(5),
            '&.contrast': {
                color: theme.palette.secondary.main
            }
        },
        sectionSubtitle: {
            fontFamily: theme.fonts.apex,
            fontSize: 'max(2vw,2vh)',
            color: theme.palette.primary.main,
            '&.contrast': {
                color: theme.palette.secondary.main
            }
        },
        carouselContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: `-${theme.spacing(10)}`,
            width: '100%',
            [theme.breakpoints.down("sm")]: {
                marginBottom: `-${theme.spacing(5)}`,
            }
        },
        carouselLeft: {
            order: 2,
        },
        carouselRight: {
            order: 2,
        },
        carousel: {
            width: '100%',
            height: 'auto',
            '& div': {
                display: 'flex',
                justifyContent: 'center',
                textAlign: "center",
                alignItems: "center",
            }
        },
        carouselImage: {
            maxWidth: '100%',
            height: 'auto',
            margin: 'auto',
            [theme.breakpoints.down('sm')]: {
                height: '50vh',
            }
        },
        indicatorContainer: {
            position: 'absolute',
            bottom: theme.spacing(2),
            textAlign: 'center',
            width: '100%',
        },
        indicator: {
            zIndex: 1000,
            margin: theme.spacing(0.5),
            color: theme.palette.secondary.main,
            '&:hover': {
                color: theme.palette.primary.main,
            }
        },
        activeIndicator: {
            color: theme.palette.primary.main,
        },
        boxTitle: {
            backgroundImage: `url(${bgWoodLight})`,
            backgroundRepeat: 'repeat',
            backgroundPosition: 'cover',
            objectFit: 'cover',
            padding: theme.spacing(5),
            paddingBottom: theme.spacing(10),
            borderRadius: '10vh',
            marginTop: theme.spacing(10),
            [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(5),
                paddingBottom: theme.spacing(10),
            }
        },
        title: {
            fontFamily: theme.fonts.poplar,
            fontSize: 'max(5vh,5vw)',
            fontWeight: "bold",
            [theme.breakpoints.down('sm')]: {
                fontSize: 'max(3vh,3vw)',
                fontWeight: "normal",
                letterSpacing: '1px',
            }
        },
        paperForm: {
            borderRadius: '3vw',
            margin: theme.spacing(10),
            marginTop: `-${theme.spacing(10)}`,
            padding: theme.spacing(10),
            backgroundImage: `url(${patternAlb})`,
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            [theme.breakpoints.down('sm')]: {
                margin: theme.spacing(4),
                marginTop: `-${theme.spacing(10)}`,
                padding: theme.spacing(3),
            },
            '& img': {
                margin: 'auto',
                justifyContent: "center",
            }
        },
        bgCream: {
            backgroundColor: theme.palette.secondary.main
        },
        arrowLeft: {
            position: "absolute",
            top: theme.spacing(10),
            left: theme.spacing(10),
        },
        arrowRight: {
            position: "absolute",
            top: theme.spacing(10),
            right: theme.spacing(10),
            '-webkit-transform': 'scaleX(-1)',
            transform: 'scaleX(-1)',
        },
    }
});

export default useOurBeersStyles;